import React from "react";
import { Card, CardContent, TextField } from "@mui/material";

const TaxCalculator = ({ financialYears, selectedYear, taxableIncome, setTaxableIncome }) => {
    const calculateTax = () => {
        if (!selectedYear || !financialYears[selectedYear]) return { tax: 0, surcharge: 0, cess: 0, totalTax: 0 };
      
        let tax = 0;
        const slabs = financialYears[selectedYear];
      
        // Sort slabs by min income (in case the order is incorrect)
        slabs.sort((a, b) => a.min - b.min);
      
        // Calculate tax based on slabs
        slabs.forEach(({ min, max, rate }) => {
          if (taxableIncome > min) {
            const taxableAmount = Math.min(taxableIncome, max) - min;
            tax += (taxableAmount * rate) / 100;
          }
        });
      
        // Calculate Surcharge based on taxable income
        let surcharge = 0;
        if (taxableIncome > 50000000) {
          surcharge = (tax * 0.37); // 37% for income above ₹5 Cr
        } else if (taxableIncome > 20000000) {
          surcharge = (tax * 0.25); // 25% for income above ₹2 Cr
        } else if (taxableIncome > 10000000) {
          surcharge = (tax * 0.15); // 15% for income above ₹1 Cr
        } else if (taxableIncome > 5000000) {
          surcharge = (tax * 0.10); // 10% for income above ₹50 Lakh
        }
      
        // Apply surcharge
        const taxWithSurcharge = tax + surcharge;
      
        // Apply Health & Education Cess (4% on tax + surcharge)
        const cess = taxWithSurcharge * 0.04;
      
        // Total Tax
        const totalTax = taxWithSurcharge + cess;
      
        return {
          tax: tax.toFixed(2),
          surcharge: surcharge.toFixed(2),
          cess: cess.toFixed(2),
          totalTax: totalTax.toFixed(2),
        };
      };
      

  return (
    <Card className="mt-5 p-4">
    <CardContent>
        <h2 className="font-bold text-lg mb-3">Tax Calculation</h2>
        
        <TextField
        type="number"
        label="Taxable Income"
        variant="outlined"
        fullWidth
        value={taxableIncome}
        onChange={(e) => setTaxableIncome(Number(e.target.value))}
        />
        
        <div className="mt-4">
        <p><strong>Base Tax:</strong> ₹{calculateTax().tax}</p>
        <p><strong>Surcharge:</strong> ₹{calculateTax().surcharge}</p>
        <p><strong>Health & Education Cess (4%):</strong> ₹{calculateTax().cess}</p>
        <hr className="my-2" />
        <p className="font-bold text-xl"><strong>Total Tax:</strong> ₹{calculateTax().totalTax}</p>
        </div>
    </CardContent>
    </Card>

  );
};

export default TaxCalculator;
